const data = {
  //Histogram Color
  "volume.volume.color.0": "#ff0a42", //first root color
  "volume.volume.color.1": "#18eed8", //second root color
  "volume.volume.transparency": 70, //transparency
  // "volume.volume ma.color": "#FF0000", //Wave Chart Color
  // "volume.volume ma.transparency": 30, //Wave Chart Transparency
  // "volume.volume ma.linewidth": 5,
  // "volume.show ma": true,    //whether to display
  // "volume.options.showStudyArguments": false,
  // "bollinger bands.median.color": "#33FF88",
  // "bollinger bands.upper.linewidth": 7,
  // // MACD style
  // "MACD.MACD.color": "#F00",
  // "MACD.Signal.color": "#fe8",
  // "MACD.Histogram.color": "#0f0",
  // 'MACD.MACD.linewidth': 1,
};

export default data;
